export default {
  labels: {
    free_items: 'Artículos gratis',
    bogo: 'Compra uno, llévate otro gratis',
    order_again: 'Pedir de nuevo',
  },
};
